export default __webpack_public_path__ + "static/media/xls.ec35c267.png";